export const GRADIENT_POLL_TIMEOUT_MS = 120000;

const FAILURE_STATES = new Set([
  'error',
  'errored',
  'fail',
  'failed',
  'failure',
  'timeout',
  'timed_out',
]);

const OK_STATES = new Set(['ok', 'ready', 'success', 'complete', 'completed']);

export const normalizeGradientState = (state) => {
  const raw =
    typeof state === 'string'
      ? state
      : state?.state ?? state?.status ?? state?.message ?? '';

  return String(raw).trim().toLowerCase();
};

export const getGradientStateKind = (state) => {
  const normalized = normalizeGradientState(state);

  if (OK_STATES.has(normalized)) return 'ok';
  if (FAILURE_STATES.has(normalized)) return 'failure';
  return 'pending';
};

export const getGradientPollingElapsedMs = (session = null, now = Date.now()) =>
  Number.isFinite(session?.startedAt) ? now - session.startedAt : 0;

export const isGradientPollingTimedOut = (
  session = null,
  now = Date.now(),
  timeoutMs = GRADIENT_POLL_TIMEOUT_MS
) => getGradientPollingElapsedMs(session, now) >= timeoutMs;

export const isGradientPollingSessionActive = (current, expected) =>
  Boolean(expected && current === expected && !expected.errorEmitted);

export const claimGradientCompletion = (session, source) => {
  if (
    !session ||
    session.shadingHandled ||
    session.completionSource ||
    typeof source !== 'string' ||
    !source.trim()
  ) {
    return false;
  }

  // Browser callbacks and poll promises share one event loop. Mutating the
  // same per-chain object before any await makes this a single atomic claim.
  session.shadingHandled = true;
  session.completionSource = source;
  return true;
};

export const buildGradientPollingError = ({
  state = null,
  elapsedMs = 0,
  timeoutMs = GRADIENT_POLL_TIMEOUT_MS,
} = {}) => {
  const kind = getGradientStateKind(state);

  if (kind === 'failure') {
    return 'Shading simulation failed while waiting for gradient results';
  }

  if (elapsedMs >= timeoutMs) {
    return 'Timed out waiting for shading gradients to finish';
  }

  return 'Shading gradients are not ready';
};
